import { useMutation } from '@tanstack/react-query';
import { handleApiResponse } from '@/functions';
import { useInvalidateQueries } from '@/hooks';
import { apiClient } from '@/components/api';
import { IAccountingUser } from '@/interfaces';
import routes from '@/lib/routes';

type TDataVariables = Partial<Omit<IAccountingUser, 'createdAt' | 'updatedAt' | 'createdByUserId'>> & { _id: string };
type TResponseData = IAccountingUser;

export const useRequestUpdateAccountingUser = () => {

    const { invalidate } = useInvalidateQueries();
    const { isPending, error, mutateAsync } = useMutation({
        mutationKey: [routes.api.accountingUsers, 'update'],
        mutationFn: (data: TDataVariables) =>
            apiClient
                .put<TResponseData>(`${routes.api.accountingUsers}/${data._id}`, data)
                .then(handleApiResponse),
        onSuccess: () => { void invalidate(routes.api.accountingUsers); }
    });

    const trigger = (data: TDataVariables) =>
        mutateAsync(data);

    return ({
        isLoading: isPending,
        trigger,
        error
    });

};
